const BG = {
  success: 'rgba(46,160,132,0.95)',
  error:   'rgba(230,106,106,0.95)',
  info:    'rgba(93,173,226,0.95)',
};

const ICONS = {
  success: '✓',
  error:   '✕',
  info:    'ℹ',
};

export default function Toast({ toasts, dismissToast }) {
  if (!toasts.length) return null;
  return (
    <div style={{ position: 'fixed', bottom: 16, right: 16, zIndex: 9999, display: 'flex', flexDirection: 'column', gap: 8 }}>
      {toasts.map((t) => (
        <div
          key={t.id}
          style={{
            background: BG[t.type] || BG.info,
            color: '#fff',
            padding: '12px 16px',
            borderRadius: 8,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 13,
            fontWeight: 500,
            minWidth: 240,
            maxWidth: 360,
          }}
        >
          <span style={{ fontWeight: 700 }}>{ICONS[t.type] || ICONS.info}</span>
          <span style={{ flex: 1 }}>{t.message}</span>
          <button
            onClick={() => dismissToast(t.id)}
            style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 16, padding: 0, lineHeight: 1, opacity: 0.8 }}
          >×</button>
        </div>
      ))}
    </div>
  );
}
